import Axios from "axios";
import { PlaceBookingDto } from "../../../features/Booking-Form/typings/booking.types";

/** Visitor invitations with per-guest `bookPlace` (mixed visit-only + workplace). */
export const postVisitorGroupBooking = (placeBookingDto: PlaceBookingDto) => {
  return Axios.post(`/booking/visitor`, placeBookingDto);
};
